import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      "/": "Login",
      "/role-login": "Role Login",
      "/register": "Register",
      
      // SuperAdmin Titles
      "/manage": "SuperAdmin Dashboard",
      "/manage-admin": "SuperAdmin: Manage Admins",
      "/add-admin": "SuperAdmin: Add Admin",
      "/update-admin": "SuperAdmin: Update Admin",
      "/manage-mandal": "SuperAdmin: Manage Mandals",
      "/add-mandal": "SuperAdmin: Add Mandal",
      "/update-mandal": "SuperAdmin: Update Mandal",
      "/mandal-info": "SuperAdmin: Mandal Info",
      "/attendance": "SuperAdmin: Attendance",
      "/manage-haribhakt": "SuperAdmin: Manage Haribhakts",
      "/add-haribhakt": "SuperAdmin: Add Haribhakt",
      "/update-haribhakt": "SuperAdmin: Update Haribhakt",
      "/sabha-report": "SuperAdmin: Sabha Report",
      "/add-report": "SuperAdmin: Add Report",
      "/update-report": "SuperAdmin: Update Report",
      "/parasabha-report": "SuperAdmin: ParaSabha Report",

      // Admin Titles
      "/admin-dashboard": "Admin Dashboard",
      "/manage-mandal1": "Admin: Manage Mandals",
      "/add-mandal1": "Admin: Add Mandal",
      "/update-mandal1": "Admin: Update Mandal",
      "/mandal-info1": "Admin: Mandal Info",
      "/attendance1": "Admin: Attendance",
      "/manage-haribhakt1": "Admin: Manage Haribhakts",
      "/add-haribhakt1": "Admin: Add Haribhakt",
      "/update-haribhakt1": "Admin: Update Haribhakt",
      "/sabha-report1": "Admin: Sabha Report",
      "/add-report1": "Admin: Add Report",
      "/update-report1": "Admin: Update Report",
      "/parasabha-report1": "Admin: ParaSabha Report",

      // MandalAdmin Titles
      "/mandal-admin-dashboard": "Mandal Admin Dashboard",
      "/manage-mandal2": "Mandal Admin: Manage Mandals",
      "/update-mandal2": "Mandal Admin: Update Mandal",
      "/mandal-info2": "Mandal Admin: Mandal Info",
      "/attendance2": "Mandal Admin: Attendance",
      "/manage-haribhakt2": "Mandal Admin: Manage Haribhakts",
      "/add-haribhakt2": "Mandal Admin: Add Haribhakt",
      "/update-haribhakt2": "Mandal Admin: Update Haribhakt",
      "/sabha-report2": "Mandal Admin: Sabha Report",
      "/add-report2": "Mandal Admin: Add Report",
      "/update-report2": "Mandal Admin: Update Report",
      "/parasabha-report2": "Mandal Admin: ParaSabha Report",

      // MandalSubAdmin Titles
      "/mandal-subadmin-dashboard": "Mandal SubAdmin Dashboard",
      "/manage-mandal3": "Mandal SubAdmin: Manage Mandals",
      "/update-mandal3": "Mandal SubAdmin: Update Mandal",
      "/mandal-info3": "Mandal SubAdmin: Mandal Info",
      "/attendance3": "Mandal SubAdmin: Attendance",
      "/manage-haribhakt3": "Mandal SubAdmin: Manage Haribhakts",
      "/add-haribhakt3": "Mandal SubAdmin: Add Haribhakt",
      "/update-haribhakt3": "Mandal SubAdmin: Update Haribhakt",
      "/sabha-report3": "Mandal SubAdmin: Sabha Report",
      "/add-report3": "Mandal SubAdmin: Add Report",
      "/update-report3": "Mandal SubAdmin: Update Report",
      "/parasabha-report3": "Mandal SubAdmin: ParaSabha Report",

      // SamparkAdmin Titles
      "/sampark-admin-dashboard": "Sampark Admin Dashboard",
      "/manage-haribhakt4": "Sampark Admin: Manage Haribhakts",
      "/update-haribhakt4": "Sampark Admin: Update Haribhakt",

      // AttendanceWorker Titles
      "/attendance-worker-dashboard": "Attendance Worker Dashboard",
      "/register-haribhakt": "Register Haribhakt",
      "/take-attendance": "Take Attendance",
      "/sabha-report4": "Attendance Worker: Sabha Report",
      "/add-report4": "Attendance Worker: Add Report",
      "/update-report4": "Attendance Worker: Update Report",
      "/parasabha-report4": "Attendance Worker: ParaSabha Report",
    };

    // Set the document title
    document.title = titles[location.pathname] || "Dashboard";
  }, [location]);
};

export default usePageTitle;
